import { AgreementLink, Container, text } from "./Agreements.Parts";

export const Agreements = ({ disabled }: { disabled: boolean }) => (
  <Container>
    {text.signature}
    <AgreementLink
      href="https://www.songtradr.com/legals/termsofuse"
      $disabled={disabled}
    >
      {text.terms}
    </AgreementLink>
    ,&nbsp;
    <AgreementLink
      href="https://www.songtradr.com/legals/privacypolicy"
      $disabled={disabled}
    >
      {text.privacyPolicy}
    </AgreementLink>
    ,&nbsp;{text.and}&nbsp;
    <AgreementLink
      href="https://www.songtradr.com/cookiepolicy"
      $disabled={disabled}
    >
      {text.cookiePolicy}
    </AgreementLink>
    .
  </Container>
);
